"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isArabic_1 = require("./isArabic");
const reference_1 = require("./reference");
function GlyphSplitter(word) {
    let letters = [];
    let lastLetter = '';
    word.split('').forEach((letter) => {
        if (isArabic_1.isArabic(letter)) {
            if (reference_1.tashkeel.indexOf(letter) > -1) {
                letters[letters.length - 1] += letter;
            }
            else if (lastLetter.length && ((reference_1.lams.indexOf(lastLetter) === 0 && reference_1.alefs.indexOf(letter) > -1) || (reference_1.lams.indexOf(lastLetter) > 0 && reference_1.alefs.indexOf(letter) === 0))) {
                // valid LA forms
                letters[letters.length - 1] += letter;
            }
            else {
                letters.push(letter);
            }
        }
        else {
            letters.push(letter);
        }
        if (reference_1.tashkeel.indexOf(letter) === -1) {
            lastLetter = letter;
        }
    });
    return letters;
}
exports.GlyphSplitter = GlyphSplitter;
